// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// core & communications
import 'babel-polyfill';
import Vue from 'vue';
import Vuetify from 'vuetify';

// HTTP Handler
import VueAxios from 'vue-axios';
import http from './http';

import logReport from './util/logReport';

// Vue UI 모듈
import VTooltip from 'v-tooltip';
import VueQuillEditor from 'vue-quill-editor';
import ToggleButton from 'vue-js-toggle-button';
import VueClipboards from 'vue-clipboards';
import VueScrollTo from 'vue-scrollto';
import LiquorTree from 'liquor-tree';
import Toasted from 'vue-toasted';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation';

// global components
import GlobalComponents from './GlobalComponents';
import GlobalEvent from './GlobalEvent';

// vue add-ons
import { store } from './store/store';
import router from './router';
import './filters';

import App from './App';
import Constant from './constants/commonText';
/* eslint-disable no-new */
import { mapGetters } from 'vuex';

import moment from 'moment';
import vueMoment from 'vue-moment';
import eventBus from '@/EventBus';
import cookies from '@/util/cookies';
import VuePlyr from 'vue-plyr';
import Uuid from 'vue-uuid';

import DialogPopup from '@/components/DialogPopup';
import VueGtag from 'vue-gtag';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import dateTimePicker from '@/components/DateTimePicker';
import datePicker from '@/components/DatePicker';
import pagination from '@/components/Pagination';
import JoditEditor from '@/components/JoditEditor';
import timePicker from '@/components/TimePicker';
import startEndTimePicker from '@/components/StartEndTimePicker';
import hoursTimePicker from '@/components/HoursTimePicker';
import Hotjar from 'vue-hotjar';
import util from '@/util/common';
import connectSocket from '@/util/call/connectSocket';

// include all css files
// Editor Css
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// nprogress
import 'nprogress/nprogress.css';

// icons
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import 'material-design-iconic-font/dist/css/material-design-iconic-font.css';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import 'animate.css/animate.min.css';
import '@fortawesome/fontawesome-free/css/all.css';

// components
import 'vue-plyr/dist/vue-plyr.css'; // only if your build system can import css, otherwise import it wherever you would import your css.

// Global Scss File
import './assets/scss/_style.scss';
import './assets/styles/vuetifyCommon.scss';
import './assets/styles/common.scss';

if (window.localStorage.getItem('LOGIN_PARAM')) {
  window.localStorage.removeItem('LOGIN_PARAM');
}

Vue.use(PerfectScrollbar);
Vue.use(VTooltip);
Vue.use(VuePlyr);
Vue.use(VueScrollTo);
Vue.use(Uuid);
Vue.use(LiquorTree);

Vue.use(Toasted, {
  action: {
    icon: 'close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
  position: 'top-right',
  duration: 3000
});

moment.locale('kr', {
  relativeTime: {
    future: '%s 후',
    past: '%s 전',
    s: '방금',
    ss: '%d초',
    m: '1분',
    mm: '%d분',
    h: '1시간',
    hh: '%d시간',
    d: '1일',
    dd: '%d일',
    M: '1개월',
    MM: '%d개월',
    y: '1년',
    yy: '%d년'
  }
});
Vue.prototype.$moment = moment;
Vue.prototype.$const = Constant;
Vue.prototype.$cookie = cookies;
Vue.prototype.$logReport = logReport;
Vue.prototype.$util = util;

Vue.use(VueGtag, {
  config: {
    id: process.env.GOOGLE_ANALYTICS
  }
});

Vue.use(Vuetify, {
  iconfont: 'mdi'
});

Vue.config.productionTip = false;

Vue.use(VueAxios, http);

Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return eventBus;
    }
  }
});

// plugins
Vue.use(Vuetify, {
  theme: store.getters.selectedTheme.theme
});

Vue.use(VueQuillEditor);
Vue.use(ToggleButton);
Vue.use(VueClipboards);
Vue.use(GlobalComponents);
Vue.use(GlobalEvent);
Vue.use(Hotjar, {
  id: process.env.HOTJAR_ID
});
Vue.use(vueMoment);

Vue.component('DialogPopup', DialogPopup);
Vue.component('dateTimePicker', dateTimePicker);
Vue.component('datePicker', datePicker);
Vue.component('pagination', pagination);
Vue.component('JoditEditor', JoditEditor);
Vue.component('timePicker', timePicker);
Vue.component('startEndTimePicker', startEndTimePicker);
Vue.component('hoursTimePicker', hoursTimePicker);
Vue.component('lottieAnimation', LottieAnimation);
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  computed: {
    ...mapGetters([
      'IS_CONNECTED',
      'IS_TICKET_CONNECTED',
      'enabledCallAgent',
      'IS_CALL_CONNECTED',
      'IS_TEL_ING',
      'callMode',
      'IS_OFFLINE',
      'getCallBrandList',
      'isKtOrKlcns',
      'isNeomecca'
    ])
  },
  watch: {
    IS_CALL_CONNECTED(val) {
      if (val) {
        this.callRetryCount = 0;
      }
    }
  },
  created() {
    let style = document.createElement('link');
    style.type = 'text/css';
    style.rel = 'stylesheet';
    style.href = `//public-common-sdk.s3.ap-northeast-2.amazonaws.com/fonts/twc${
      process.env.NODE_ENV === 'production' ? '' : '-dev'
    }.css?timestemp=${new Date().getTime()}`;
    document.head.appendChild(style);
    document.addEventListener('beforeunload', this.handler);
  },
  mounted() {
    eventBus.$on('reconnect-start', () => {
      setTimeout(() => {
        console.log('재연결 시도 하기');
        this.retryConnect();
      }, 3000);
    });
    eventBus.$on('ticket-reconnect-start', () => {
      console.log('티켓 소켓 재연결 시도');
      this.retryTicketConnect();
    });
    eventBus.$on('call-reconnect-start', () => {
      if (this.IS_OFFLINE) {
        this.$logReport.write('[SOCKET] - 오프라인 > 콜 소켓 재연결 취소');
        return;
      }
      if (this.isNeomecca || this.IS_TEL_ING !== false) {
        this.$logReport.write('[SOCKET] - 콜 소켓 재연결 시도');
        store.dispatch('CLOSE_CALL');
        this.retryCallConnect();
      }
    });
  },
  destroyed() {
    eventBus.$off('reconnect-start');
    eventBus.$off('ticket-reconnect-start');
    eventBus.$off('call-reconnect-start');
  },
  data() {
    return { ticketRetryCount: 0, interval: undefined, callRetryCount: 0, callApiRetryCount: 0 };
  },
  methods: {
    handler: function handler(event) {
      // TODO : 구독중인 모든 방을 unscribe 한다
    },
    retryConnect() {
      store.dispatch('connect');
    },
    retryTicketConnect() {
      setTimeout(() => {
        if (this.ticketRetryCount < 5) {
          store.dispatch('ticket_connect');
          this.ticketRetryCount += 1;
        } else {
          console.log('server error');
        }
      }, 500);
    },
    retryCallConnect() {
      setTimeout(async () => {
        if (this.callRetryCount < 5) {
          if (this.callRetryCount === 4) {
            this.$store.commit('setCallPort', '3025');
          }

          await connectSocket.initCall();
          connectSocket.connectCallSocket();

          this.callRetryCount += 1;
        } else {
          this.$store.commit('removeBeforeNotify');
          if (this.enabledCallAgent) {
            this.$toasted.error('서버에 연결할 수 없습니다.');
          }
          if (this.isKtOrKlcns) {
            eventBus.$emit('DialogPopup', {
              useDialog: true,
              messageHTML:
                '<dl class="txt"><dd>네트워크가 원활하지 않아<br/>사용자 요청을 완료하지 못했습니다.<br/>잠시 후 다시 시도해주세요.</dd></dl>',
              getBtnCount: 1
            });
          }
          if (this.enabledCallAgent) {
            const array = new ArrayBuffer(29);
            const buffer = new Uint8Array(array);
            store.dispatch('sendMessageToCallSocket', buffer);
          } else {
            console.log('server error');
          }
        }
      }, 3000);
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js